import { SET_Wiki_Create_Config } from './types';

const initialState = {
  createConfig: {},
};

export default (state = initialState, action = {}) => {
  // console.log("STATE",action)
  switch (action.type) {
    case SET_Wiki_Create_Config:
      return {
        ...state,
        createConfig: action.config,
      };
    default:
      return state;
  }
};
